import React, { useEffect, useState } from 'react';
import parse from "html-react-parser";
import {
  Grid,
  Paper
} from '@material-ui/core';

import wpServices from 'Services/wpService';
import CommonLoader from 'Views/Common/CommonLoader';
import clsx from 'clsx';
import LayoutView from "Views/Common/LayoutView";
import { SectionHeader } from 'components';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

const PrivacyPolicy = () => {
  const [privacyContent, setContent] = useState();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const getPrivacyPolicy = async () => {
        const response = await wpServices.getPrivacyPolicy('/legal-pages?filters[slug][$eq]=privacy-policy&populate=*');   
        setContent(response);
        setLoading(false);
    };

    getPrivacyPolicy();
  }, []);

  return (
    <>
      <SectionHeader
        title=""
        titleVariant="h4"
        titleComponent="h4"
        rightSection={
          <Paper className={clsx('widget-wrapper')} elevation={0}>

            {
              isLoading ?
                <CommonLoader />
                :
                <Grid item xs={12}>
                  {privacyContent?.data?.revision_notice && (
                    <div style={{ 
                      marginTop: '20px', 
                      marginBottom: '24px',
                      padding: '16px 20px', 
                      backgroundColor: '#f5f5f5', 
                      borderRadius: '6px',
                      fontSize: '14px',
                      color: '#666',
                      lineHeight: '1.5'
                    }}>
                      {privacyContent?.data?.revision_notice}
                    </div>
                  )}
                  <div style={{
                    fontSize: '20px',
                    lineHeight: '1.6',
                    color: '#333'
                  }}>
                    <style>
                    {`
                      .privacy-content p {
                        margin: 0 0 16px 0 !important;
                        line-height: 1.6;
                        font-size: 16px;
                        color: #333;
                      }
                      .privacy-content h1, 
                      .privacy-content h2, 
                      .privacy-content h3, 
                      .privacy-content h4, 
                      .privacy-content h5, 
                      .privacy-content h6 {
                        margin: 24px 0 16px 0 !important;
                        font-weight: 600;
                        color: #333;
                      }
                      .privacy-content h4 { font-size: 24px; }
                      .privacy-content h5 { font-size: 18px; }
                      .privacy-content h6 { font-size: 14px; }
                      .privacy-content ul {
                        margin: 0 0 16px 0 !important;
                        padding: 0 0 0 20px;
                      }
                      .privacy-content ul li {
                        margin: 0 0 8px 0 !important;
                        list-style: disc;
                        line-height: 1.5;
                        font-size: 16px;
                        color: #333;
                      }
                    `}
                    </style>
                    <div className="privacy-content">
                      <ReactMarkdown 
                        remarkPlugins={[remarkGfm]}
                        rehypePlugins={[rehypeRaw]}
                      >
                        {privacyContent?.data?.description}
                      </ReactMarkdown>
                    </div>
                  </div>
                </Grid>
            }

          </Paper>
        }
      >
      </SectionHeader>
    </>
  );
};

export default PrivacyPolicy;
